import "../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { ref as n, readonly as e } from "../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { watch as a } from "../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function c(r) {
  const t = n(!!r.value);
  if (t.value)
    return e(t);
  const u = a(r, (o) => {
    o && (t.value = !0, u());
  });
  return e(t);
}
export {
  c as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vooks@0.2.12_vue@3.5.18/~/vooks/es/use-false-until-truthy.js
// module id = 1736
// module chunks = 41